// 3rd-party
import React, { useEffect, useState } from "react";
import { IconButton, Typography, Button, Box, Popover } from "@mui/material";
import { useNavigate } from "react-router-dom";
import LensSharpIcon from "@mui/icons-material/LensSharp";

// Asset components
import logoutrLogo from "../../assets/logouticon.svg";
import profile from "../../assets/profileIcon.svg";

// Services
import { getStorageItemLocal } from "../../services/storageServices";

// Styles
import "./Logout.scss";

const LogOut: React.FC = () => {
  // useNavigate
  const navigate = useNavigate();

  // useState
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [username, setUsername] = useState<string>("");
  const [role, setRole] = useState<string>("");

  // Derived state
  const isOpen = Boolean(anchorEl);

  useEffect(() => {
    const storedUsername = getStorageItemLocal("username");

    const storedRole = getStorageItemLocal("role");

    if (storedUsername) setUsername(JSON.parse(storedUsername));
    if (storedRole) setRole(JSON.parse(storedRole));
  }, []);

  const toggleDropdown = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };

  const logout = () => {
    localStorage.clear();
    navigate("/");
  };

  return (
    <div className="logout-container">
      <IconButton onClick={toggleDropdown}>
        {/* <LensSharpIcon className="icons-account" /> */}
        <img src={profile} alt="Logo" className="icons-account" />
        <img src={logoutrLogo} alt="Logo" />
      </IconButton>

      <Popover
        open={isOpen}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        PaperProps={{
          className: "dropdown-card",
          style: {
            zIndex: 2000,
            opacity: 1,
          },
        }}
      >
        <Box className="dropdown-box">
          <Typography variant="h6" className="user-name">
            {username}
          </Typography>
          <Typography variant="body1" className="user-role">
            {role}
          </Typography>
          <Button
            className="logout-button"
            variant="contained"
            onClick={logout}
          >
            Logout
          </Button>
        </Box>
      </Popover>
    </div>
  );
};

export default LogOut;
